import DashboardIcon from "../assets/images/icons/active/dashboard_white@3x.png";
import InactiveDashboardIcon from "../assets/images/icons/inactive/dashboard dissable@3x.png";
import SpecialistDashboard from "../pages/CustomerSpecialist/Dashboard/SpecialistDashboard";
import Profile from "../pages/CustomerSpecialist/Profile/Profile";

var CustomerSpecialistRoutes = [
  {
    path: "dashboard",
    name: "Dashboard",
    element: <SpecialistDashboard />,
    layout: "specialist",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
   {
    path: "profile",
    name: "Profile",
    element: <Profile />,
    layout: "specialist",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
];
export default CustomerSpecialistRoutes;
